'use client'

import { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'
import { t } from '../lib/i18n'

/**
 * Lightweight GDPR/LSSI cookie notice. Shows once until accepted (localStorage).
 * NOTE: this is a notice, not a full consent-management platform. Before turning on
 * display ads, upgrade to Google Consent Mode v2 (gate GTM/ads on consent).
 *
 * The locale comes from the PATH, not from headers()/cookies(). Reading those in a shared layout
 * opts every route into dynamic rendering and silently destroys the static build — and static HTML
 * is the product here. Header and SiteFooter derive it the same way.
 *
 * This bar sits on EVERY page, so while it was Spanish-only it was the single most widespread piece
 * of untranslated copy on the English tree.
 */
export default function CookieConsent() {
  const [show, setShow] = useState(false)
  const pathname = usePathname() || '/'
  const locale = pathname === '/en' || pathname.startsWith('/en/') ? 'en' : 'es'
  const T = t(locale)

  useEffect(() => {
    try {
      if (!localStorage.getItem('dp-cookie-consent')) setShow(true)
    } catch {
      /* localStorage unavailable */
    }
  }, [])

  if (!show) return null

  const accept = () => {
    try {
      localStorage.setItem('dp-cookie-consent', '1')
    } catch {
      /* ignore */
    }
    setShow(false)
  }

  return (
    <div className="cookieBar" role="dialog" aria-label={T.cookieAria}>
      <span>
        {T.cookieNotice}{' '}
        <a href="/cookies">{T.cookieMore}</a>.
      </span>
      <button className="cookieBar__accept" onClick={accept}>
        {T.cookieAccept}
      </button>
    </div>
  )
}
